<template>
  <div>
    <div class="banner">
      <div class="headerReplacementBasicInfo"></div>
      <div class="banner-text">
        <b>การจ่ายเงินปันผล</b>
        <div class="breadcrumb">
          <span><router-link to="/" class="pe-auto">หน้าหลักนักลงทุนสัมพันธ์</router-link></span>
          <span class="separator"></span>
          <span>ข้อมูลผู้ถือหุ้น</span>
          <span class="separator"></span>
          <span><b>การจ่ายเงินปันผล</b></span>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="TabMenu">
        <BasicInfoTabMenu />
      </div>
      <div v-html="textAbout" class="mb-4 mt-5">
        {{ textAbout }}
      </div>

      <div class="table-responsive">
        <table class="table text-center mb-5">
          <thead class="table-secondary">
            <tr>
              <th><b>วันที่กรรมการมีมติ</b></th>
              <th><b>วันที่ขึ้นเครื่องหมาย</b></th>
              <th><b>วันที่จ่ายเงินปันผล</b></th>
              <th><b>ประเภทเงินปันผล</b></th>
              <th><b>เงินปันผลต่อหุ้น (บาท)</b></th>
              <th><b>รอบผลประกอบการ</b></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(record, index) in dividendData" :key="index">
              <td>{{ record.decisionDate }}</td>
              <td>{{ record.exDividendDate }}</td>
              <td>{{ record.paymentDate }}</td>
              <td>{{ record.type }}</td>
              <td>{{ record.dividendPerShare }}</td>
              <td>{{ record.reportingPeriod }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import BasicInfoTabMenu from '@/components/BasicInfoTabMenu.vue';

export default {
  name: 'Info',
  components: {
    BasicInfoTabMenu,
  },
  data() {
    return {
      textAbout: "บริษัทมีนโยบายการจ่ายเงินปันผลให้แก่ผู้ถือหุ้นปีละ 2 ครั้ง ในอัตรารวมแล้วไม่น้อยกว่าร้อยละ 40 ของกำไรสำหรับปีของสุทธิตามงบการเงินได้นิติบุคคล และหลังหักสำรองต่างๆ ทุกประเภทที่กฎหมายและบริษัทฯ กำหนดไว้ในแต่ละปี <br> ทั้งนี้ คณะกรรมการบริษัทฯ จะพิจารณาการจ่ายเงินปันผลโดยคำนึงถึงปัจจัยต่างๆ เพื่อผลประโยชน์ต่อผู้ถือหุ้นเป็นหลัก เช่น ผลการดำเนินงานและฐานะทางการเงินของบริษัทฯ การสำรองเงินไว้เพื่อลงทุนในอนาคต การสำรองเงินไว้เพื่อจ่ายชำระคืนเงินกู้ยืม หรือเป็นเงินทุนหมุนเวียนภายในบริษัทฯ และการจ่ายเงินปันผลนั้นไม่มีผลกระทบต่อการดำเนินงานปกติของบริษัทฯ อย่างมีนัยสำคัญ ตามที่คณะกรรมการบริษัทฯ พิจารณาเห็นสมควรหรือเหมาะสม",
      dividendData: [
        { decisionDate: '29/02/2567', exDividendDate: '08/05/2567', paymentDate: '23/05/2567', type: 'เงินปันผล', dividendPerShare: '0.30', reportingPeriod: '01/07/2566-31/12/2566' },
        { decisionDate: '15/08/2566', exDividendDate: '28/08/2566', paymentDate: '13/09/2566', type: 'เงินปันผล', dividendPerShare: '0.16', reportingPeriod: '01/01/2566-30/06/2566' },
        { decisionDate: '28/02/2566', exDividendDate: '08/05/2566', paymentDate: '25/05/2566', type: 'เงินปันผล', dividendPerShare: '0.57', reportingPeriod: '01/07/2565-31/12/2565' },
        { decisionDate: '15/08/2565', exDividendDate: '26/08/2565', paymentDate: '13/09/2565', type: 'เงินปันผล', dividendPerShare: '0.15', reportingPeriod: '01/01/2565-30/06/2565' },
        { decisionDate: '28/02/2565', exDividendDate: '09/05/2565', paymentDate: '24/05/2565', type: 'เงินปันผล', dividendPerShare: '0.42', reportingPeriod: '01/07/2564-31/12/2564' },
        { decisionDate: '11/08/2564', exDividendDate: '24/08/2564', paymentDate: '09/09/2564', type: 'เงินปันผล', dividendPerShare: '0.12', reportingPeriod: '01/01/2564-30/06/2564' },
        { decisionDate: '29/04/2564', exDividendDate: '07/05/2564', paymentDate: '18/05/2564', type: 'เงินปันผล', dividendPerShare: '0.39', reportingPeriod: '01/10/2563-31/12/2563' },
        { decisionDate: '24/12/2563', exDividendDate: '08/01/2564', paymentDate: '22/01/2564', type: 'เงินปันผล', dividendPerShare: '0.10', reportingPeriod: '01/01/2563-30/09/2563' },
        { decisionDate: '14/05/2563', exDividendDate: '01/09/2563', paymentDate: '25/09/2563', type: 'เงินปันผล', dividendPerShare: '0.29', reportingPeriod: '01/07/2562-31/12/2562' },
        { decisionDate: '14/08/2562', exDividendDate: '28/08/2562', paymentDate: '13/09/2562', type: 'เงินปันผล', dividendPerShare: '0.205', reportingPeriod: '01/01/2562-30/06/2562' },
        { decisionDate: '25/04/2562', exDividendDate: '02/05/2562', paymentDate: '15/05/2562', type: 'เงินปันผล', dividendPerShare: '0.30', reportingPeriod: '01/10/2561-31/12/2561' },
        { decisionDate: '22/12/2561', exDividendDate: '04/01/2562', paymentDate: '18/01/2562', type: 'เงินปันผล', dividendPerShare: '0.06', reportingPeriod: '01/01/2561-30/09/2561' },
        { decisionDate: '10/08/2561', exDividendDate: '16/10/2561', paymentDate: '31/10/2561', type: 'หุ้นปันผล', dividendPerShare: '2.00 : 1.00', reportingPeriod: '01/01/2561-30/06/2561' },
        { decisionDate: '', exDividendDate: '', paymentDate: '', type: 'เงินปันผล', dividendPerShare: '0.04', reportingPeriod: '' },
        { decisionDate: '28/02/2561', exDividendDate: '08/05/2561', paymentDate: '25/05/2561', type: 'เงินปันผล', dividendPerShare: '0.55', reportingPeriod: '01/07/2560-31/12/2560' },
        { decisionDate: '23/09/2560', exDividendDate: '05/10/2560', paymentDate: '20/10/2560', type: 'เงินปันผล', dividendPerShare: '0.05', reportingPeriod: '01/01/2560-30/06/2560' },
        { decisionDate: '28/02/2560', exDividendDate: '17/04/2560', paymentDate: '03/05/2560', type: 'หุ้นปันผล', dividendPerShare: '2.50 : 1.00', reportingPeriod: '01/10/2559-31/12/2559' },
        { decisionDate: '', exDividendDate: '', paymentDate: '', type: 'เงินปันผล', dividendPerShare: '0.04', reportingPeriod: '' },
        { decisionDate: '14/11/2559', exDividendDate: '24/11/2559', paymentDate: '29/12/2559', type: 'หุ้นปันผล', dividendPerShare: '1.50 : 1.00', reportingPeriod: '01/07/2559-30/09/2559' },
        { decisionDate: '', exDividendDate: '', paymentDate: '', type: 'เงินปันผล', dividendPerShare: '0.0371', reportingPeriod: '' },
        { decisionDate: '13/08/2559', exDividendDate: '29/08/2559', paymentDate: '12/09/2559', type: 'เงินปันผล', dividendPerShare: '0.104', reportingPeriod: '01/01/2559-30/06/2559' },
        { decisionDate: '24/02/2559', exDividendDate: '08/03/2559', paymentDate: '04/05/2559', type: 'หุ้นปันผล', dividendPerShare: '10.00 : 1.00', reportingPeriod: '01/07/2558-31/12/2558' },
        { decisionDate: '', exDividendDate: '', paymentDate: '', type: 'เงินปันผล', dividendPerShare: '0.16667', reportingPeriod: '' },
      ]
    };
  }

};
</script>

<style scoped>
th {
  font-weight: normal;
}

.table {
  margin-bottom: 0;
}
</style>
